import { existsSync, readFileSync } from 'node:fs';
import { join } from 'node:path';
import shell from 'shelljs';

import { pwd } from './codebase';

/**
 * @param path 路径
 * @param interrupt 出错是否中断进程
 * @returns
 */
export const getJson = <T>(path: string, interrupt: boolean): T => {
  try {
    const config = readFileSync(path, {
      encoding: 'utf-8',
    });
    return JSON.parse(config) as T;
  } catch (error) {
    if (interrupt) {
      throw new Error(error instanceof Error ? error.message : String(error));
    }
    return {} as T;
  }
};

/**
 * @param command 命令 这个utils内部用用吧，其他package就正常使用shelljs
 * @param silent 是否 隐藏脚本log
 * @returns
 */
export const runShell = (command: string, options = { silent: true, cwd: pwd }): string => {
  return shell.exec(command, options).stdout.trim();
};

/**
 * @param path
 * @returns
 */
export const exists = (path: string) => {
  return existsSync(path);
};

/**
 * @param cwd
 * @returns
 */
export const isGitRepo = (cwd: string) => {
  return exists(join(cwd, '.git'));
};

/** 获取 try..catch 或 promise..catch 中的 unknown 的 error 的 message */
export function getUnknowErrorMsg(error: unknown) {
  let message = '';
  if (error instanceof Error) {
    ({ message } = error);
  } else if (typeof error === 'object' && error !== null && 'message' in error) {
    ({ message } = error as { message: string });
  } else if (typeof error === 'object' && error !== null && 'error' in error) {
    ({ error: message } = error as { error: string });
  } else {
    message = String(error);
  }
  return message;
}

export function typedObjectKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}
